module.exports = __webpack_public_path__ + "img/mono-square.0cb1255c.svg";